import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FolderKanban, Loader2 } from "lucide-react";
import { AdminGetAllProject } from "../../AdminServices/AdminProjectService";
import CreateProjectModal from "../AdminModals/CreateProjectModal";
import frameBg from "../../../../Assets/FrameBGDashboard.png";

const AdminAllProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await AdminGetAllProject();

        if (res.data.status === "Success") {
          setProjects(res.data.data);
        } else {
          setError("Failed to load project data.");
        }
      } catch {
        setError("Something went wrong while loading projects.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); 

  return (
    <div className="min-h-screen w-full">
      <div
        className="relative rounded-lg overflow-hidden shadow-md text-white mx-0"
        style={{
          backgroundImage: `url(${frameBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="p-8 flex justify-between items-center">
          <h2 className="text-2xl font-semibold">All Projects</h2>

          <button
            onClick={() => setShowModal(true)}
            className="bg-[#003a63] text-white px-5 py-2 rounded-lg"
          >
            + Create Project
          </button>
        </div>
      </div>

      <div className="p-6 md:p-10">
        {loading && (
          <div className="flex justify-center mt-20">
            <Loader2 className="animate-spin text-[#0061A4]" size={40} />
          </div>
        )}

        {error && (
          <p className="text-center text-red-500 font-medium">{error}</p>
        )}

        {!loading && !error && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects.map((p) => (
              <div
                key={p.projectUID}
                onClick={() => navigate(`/Admin-Project-Team/${p.projectUID}`)}
                className="bg-white/70 backdrop-blur-md shadow-lg rounded-xl p-6 border border-gray-200 
                           hover:shadow-2xl hover:-translate-y-1 transition-all cursor-pointer group"
              >
                <div className="flex justify-center mb-4">
                  <div className="p-4 bg-[#E8F3FF] rounded-full group-hover:bg-[#d5eaff] transition">
                    <FolderKanban className="text-[#0061A4]" size={34} />
                  </div>
                </div>

                <h2 className="text-xl font-semibold text-center text-[#0061A4]">
                  {p.projectName}
                </h2>
              </div>
            ))}
          </div>
        )}
      </div>

      <CreateProjectModal
        show={showModal}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
};

export default AdminAllProjects;
